module.exports = __webpack_public_path__ + "static/media/chat_right.be73c9c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/comic_theme/chat_right.svg
// module id = 444
// module chunks = 0